module.exports = __webpack_public_path__ + "static/img/Oval9.b37e28ac.png";